import styled from 'styled-components';

import { Text } from '@catalyze/ui';

export const StyledText = styled(Text)`
    margin-top: 1rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.formLabel};
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;
